import { useEffect, useRef } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";

/**
 * Auto-fits the map to the given points when they change significantly.
 * Only runs once per significant change (by count signature) to avoid fighting user panning.
 */
export default function FitBounds({ points = [] }) {
  const map = useMap();
  const lastSigRef = useRef("");

  useEffect(() => {
    if (!map || points.length === 0) return;
    const sig = `${points.length}-${points[0]?.lat?.toFixed(3)}-${points[0]?.lng?.toFixed(3)}`;
    if (sig === lastSigRef.current) return;
    lastSigRef.current = sig;
    try {
      const bounds = L.latLngBounds(points.map(p => [p.lat, p.lng]));
      if (bounds.isValid()) {
        map.fitBounds(bounds.pad(0.15), { animate: true, maxZoom: 14 });
      }
    } catch (err) {
      console.warn("FitBounds: unable to fit bounds", err);
    }
  }, [map, points]);

  return null;
}
